import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LeaveRequestTypePage from './LeaveRequestTypePage';

const LeaveRequestTypePageWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return <LeaveRequestTypePage navigate={navigate} location={location} />;
};

export default LeaveRequestTypePageWrapper;
